import * as React from "react";

function UserFilled(props) {
  return <svg viewBox="0 0 24 24" fill="none" {...props}><g fill="currentColor"><circle cx={12} cy={7} r={5} /><path fillRule="evenodd" clipRule="evenodd" d="M5.31 21.633c-1.683-.721-2.367-2.755-1.252-4.21A9.984 9.984 0 0112 13.5a9.984 9.984 0 017.942 3.923c1.115 1.455.431 3.489-1.253 4.21A16.944 16.944 0 0112 23c-2.375 0-4.636-.487-6.69-1.367z" /></g></svg>;
}

export default UserFilled;